module.exports = __webpack_public_path__ + "static/media/p18_triangle.9093bac4.txt";